// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2LogM","footer":"ModalInfo_footer__1hNta"};